import { ProductCategoriesLink } from "components/Navbar/types"
import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { Box, Loader } from "@strapi/design-system"

export const LoginPagesLayout: React.FC = () => {
  const navigate = useNavigate()
  const { username, userExpired } = useAppSelector((state) => state.user.userInfo)
  const productsCategories = useAppSelector((state) => state.products.productsCategories)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)

  useEffect(() => {
    setIsCheckingAuth(true)
    if (username && !userExpired)
      if (productsCategories.length > 0) navigate(productsCategories[0].to, { replace: true })
      else navigate(ProductCategoriesLink.MAKEUP, { replace: true })
    else navigate("/login")

    setIsCheckingAuth(false)
  }, [username, navigate])

  return isCheckingAuth ? (
    <Box
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loader />
    </Box>
  ) : (
    <Outlet />
  )
}
